// eslint-disable-next-line import/prefer-default-export
export function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/date-picker/utils.js
// module id = 314
// module chunks = 0